import { EvironmentAPI } from 'src/environments/enviroments.api';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './../auth/auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  // private loginUrl = '//services.focustextil.com.br/node/express/setuser?query=';
  private passwordUrl = EvironmentAPI.webrep + 'api/v1/ForgotPassword';
  private cadastroUrl = '//services.focustextil.com.br/node/server/index.js?service=Cliente.svc/client/&query=';
  private cepUrl = '//services.focustextil.com.br/node/server/index.js?service=CEP.svc/cep/&query=';


  // private loginUrl = 'http://189.126.197.169/node/express/setuser?query=';
  // private passwordUrl = 'http://189.126.197.169/node/server/login.js?service=Login.svc/changePassword&query=';
  // private cadastroUrl = 'http://189.126.197.169/node/server/index.js?service=Cliente.svc/client/&query=';
  // private cepUrl = 'http://189.126.197.169/node/server/index.js?service=CEP.svc/cep/&query=';



  private usuarioSource = new BehaviorSubject('');
  usuario = this.usuarioSource.asObservable();

  private tipoUsuarioSource = new BehaviorSubject('');
  tipoUsuario = this.tipoUsuarioSource.asObservable();

  constructor(
    private http: HttpClient,
    private _toastr: ToastrService,
    public auth: AuthService,
    private _cookie: CookieService
  ) {}

  login(username: string, password: string, login2: any) {
    let self = this;
    console.log(self);
    let btn:any = document.querySelector('.btn-login.change-loader');

    if( !btn.classList.contains('active') ){
      btn.classList.add('active');
      let data:any = {User: username, Password: password};

      let request = new XMLHttpRequest();
      request.open('POST', EvironmentAPI.webrep + 'api/v1/Login', true);
      request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      request.setRequestHeader('Access-Control-Allow-Origin', '*');
      let success:boolean = false;
      let error:boolean = false;
      request.send( JSON.stringify(data) );
      // setTimeout(function(){
      //   if(!success && !error){
      //     request.abort();
      //     window['Swal'].fire(
      //       'Erro:',
      //       'A conexão falhou, por favor tente novamente ou entre em contato com o administrador do site',
      //       'error'
      //     );
      //     btn.classList.remove('active');
      //   };
      // }, 60000 * 4 /* 4 min. */);
      request.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (this.status >= 200 && this.status < 400) {
            success = true;
            let response:any = JSON.parse( this.responseText );
            btn.classList.remove('active');
            login2(response, self);
          } else {
            let response:any = this.responseText;
            console.log(response);
            error = true;
            btn.classList.remove('active');
          };
        };
      };

    };
  }

  login2(response: any, self: any) {
    if (response && response.Error) {
      self._toastr.error(response.Error);
      return false;
    } else if (response && response.User.FullName.toLowerCase() == 'wrong_password') {
      self._toastr.error('Usuário ou senha incorretos!');
      return false;
    };

    delete response.User.Reps;
    delete response.User.Gestores;

    localStorage.clear(); // ?
    let hostname = window.location.hostname;
    if(hostname.startsWith('.')) {
      hostname = hostname.substring(1);
    }
    self._cookie.delete('portal');
    self._cookie.set('portal', JSON.stringify(response), 14, '/', hostname, EvironmentAPI.isPRD, 'Lax');
    console.log(self._cookie.get('portal'));
    let portal: any = JSON.parse(self._cookie.get('portal'));

    // setUser
    self.usuarioSource.next(response.User.FullName);
    self.tipoUsuarioSource.next(response.User.Tipo);
    // /setUser

    document.querySelectorAll('.dropdown-toggle')[0]['click'](); // fecha o dropdown

    self.ifPedidos_( portal ); // if cliente then redirect

    /* else if (self.route.snapshot.queryParams['redirectTo']) {
      self._router.navigate([self.route.snapshot.queryParams['redirectTo']]);
    };*/
  }

  setUser(portal: any) {
    if( portal !== '' ){
      this.usuarioSource.next(portal.User.FullName);
      this.tipoUsuarioSource.next(portal.User.Tipo);
    }else{
      this.usuarioSource.next('LOGIN');
      this.tipoUsuarioSource.next('');
    };
  }


  ifPedidos_(portal: any){
    if(typeof portal == 'undefined'){
      portal = JSON.parse(this._cookie.get('portal'));
    };
    let ifBoleto: any = portal.User.Sistemas.indexOf('Boleto') > -1;
    let ifCliente: any = portal.User.Tipo.toLowerCase() == 'cliente';
    if (ifBoleto && ifCliente) {
      let link: string = EvironmentAPI.boleto;
      window.location.href = link;
      setTimeout(function(){
        window.location.href = link;
      }, 3000);
    };
    return false;
  }

  ifBoleto_(portal: any){
    if(typeof portal == 'undefined'){
      portal = this._cookie.get('portal');
      if(portal !== ''){
        portal = JSON.parse(portal);
      }else{
        portal = {User: {FullName: 'LOGIN', Tipo: 'Nenhum', Sistemas: ['']}};
      };
    };
    let ifBoleto: any = portal.User.Sistemas.indexOf('Boleto') > -1;
    if (ifBoleto) {
      return true;
    };
    return false;
  }

  ifDanfeXML_(portal: any){
    if(typeof portal == 'undefined'){
      portal = this._cookie.get('portal');
      if(portal !== ''){
        portal = JSON.parse(portal);
      }else{
        portal = {User: {FullName: 'LOGIN', Tipo: 'Nenhum', Sistemas: ['']}};
      };
    };
    let ifDanfeXML_: any = portal.User.Sistemas.indexOf('DanfeXml') > -1;
    if (ifDanfeXML_) {
      return true;
    };
    return false;
  }

  ifWebRep_(portal: any){
    if(typeof portal == 'undefined'){
      portal = this._cookie.get('portal');
      if(portal !== ''){
        portal = JSON.parse(portal);
      }else{
        portal = {User: {FullName: 'LOGIN', Tipo: 'Nenhum', Sistemas: ['']}};
      };
    };
    let ifWebRep: any = portal.User.Sistemas.indexOf('WebRep') > -1;
    if (ifWebRep) {
      return true;
    };
    return false;
  }

  resetPassword(username: string): Observable<any> {
    return this.http.get<any>(this.passwordUrl + username);
  }

  changePassword(username: string, password: string, newpassword: string): Observable<any> {
    return this.http.get<any>(this.passwordUrl + username + '/' + password + '/' + newpassword);
  }

  cadastroCliente(cnpj: string, razao: string, ie: string, isento: string, cep: string, rua: string, numero: string, complemento: string, bairro: string, cidade: string, estado: string, pais: string, nome: string, sobrenome: string, email: string, ddd1: string, telefone1: string, ddd2: string, telefone2: string, senha: string): Observable<any> {
    // isento = x;
    return this.http.get<any>(this.cadastroUrl + cnpj + '/' + razao + '/' + ie + '/' + isento + '/' + cep + '/' + rua + '/' + numero + '/' + complemento + '/' + bairro + '/' + cidade + '/' + estado + '/' + pais + '/' + nome + '/' + sobrenome + '/' + email + '/' + ddd1 + '/' + telefone1 + '/' + ddd2 + '/' + telefone2 + '/' + senha + '/0');

    // Cadastro Enviado com Sucesso!
    // Obrigado por fazer seu cadastro na Focus Têxtil. Aguarde contato de um representante Focus para finalizar o seu cadastro e receber seu login e senha.
  }

  cep(cep: string):Observable<any> {
    return this.http.get<any>(this.cepUrl + cep);
  }
}